import { useGetSwiftlaneUserGroups } from '@/api/keyless/swiftlane/get-swiftlane-user-groups'

// Note: shared by every surface that needs to know whether a building's Swiftlane integration
// is actually usable right now — Places → Integrations (the connection status pill, via
// `use-swiftlane-connection.ts`) and the resident profile's Keyless Access tab (both designs),
// which used to trust a static `swiftlaneAvailable` building flag with no live check at all.
// `/swiftlane/user-group/:buildingId` is reused as a pure existence probe — same endpoint the
// resident tab already calls to populate its access-level dropdown, just gated on `isSuccess`
// here instead of being discarded.
export const useIsSwiftlaneBuildingConnected = (buildingId: number) => {
  const { isLoading, isSuccess } = useGetSwiftlaneUserGroups({ buildingId })

  return {
    isBuildingConnected: isSuccess,
    isLoading,
  }
}
